import { CustomerSpecificationTypeEntity } from '../../entities/customerSpecificationType.entity';
import { createReducer, on } from '@ngrx/store';
import { CustomerSpecificationTypeActionTypes } from '../actions/customerSpecificationType.actions';


export const customerSpecificationTypesFeatureKey = 'customerSpecificationTypes';

export interface CustomerSpecificationTypeState {
    customerSpecificationTypes: CustomerSpecificationTypeEntity[];
}

export const initialState: CustomerSpecificationTypeState = {
    customerSpecificationTypes: null,
};

export const CustomerSpecificationTypeReducer = createReducer(
    initialState,
    on(CustomerSpecificationTypeActionTypes.AddSuccess, (state, { Payload }) => ({
        ...state,
        customerSpecificationTypes: [...state.customerSpecificationTypes, Payload],
    })),

    on(CustomerSpecificationTypeActionTypes.ChangeSuccess, (state, { Payload }) => ({
        ...state,
        customerSpecificationTypes: state.customerSpecificationTypes.map((entity) =>
            entity.Id === Payload.Id
                ? entity.Clone({ ...Payload })
                : entity
        ),
    })),
    on(CustomerSpecificationTypeActionTypes.DeleteSuccess, (state, { Payload }) => ({
        ...state,
        customerSpecificationTypes: state.customerSpecificationTypes.filter(
            (entity) => entity.Id !== Payload
        ),
    })),
    on(CustomerSpecificationTypeActionTypes.UpdateCustomerSpecificationType, (state, { Payload }) => ({
        ...state,
        customerSpecificationTypes: Payload,
    })),

);
